import { getHttpClient } from '@shared/services';

import {
  authUserSchema,
  loginResponseSchema,
  refreshResponseSchema,
  type AuthUser,
  type LoginInput,
  type LoginResponse,
  type RefreshResponse,
} from '../validations';

export const authService = {
  async login(input: LoginInput): Promise<LoginResponse> {
    const { data } = await getHttpClient().post<unknown>('/auth/login', {
      email: input.email,
      password: input.password,
    });
    const envelope = data as { data?: unknown };
    return loginResponseSchema.parse(envelope.data ?? data);
  },

  async refresh(refreshToken: string): Promise<RefreshResponse> {
    const { data } = await getHttpClient().post<unknown>('/auth/refresh', { refreshToken });
    const envelope = data as { data?: unknown };
    return refreshResponseSchema.parse(envelope.data ?? data);
  },

  async me(): Promise<AuthUser> {
    const { data } = await getHttpClient().get<unknown>('/auth/me');
    const envelope = data as { data?: unknown };
    return authUserSchema.parse(envelope.data ?? data);
  },

  async logout(refreshToken?: string): Promise<void> {
    await getHttpClient().post('/auth/logout', refreshToken !== undefined ? { refreshToken } : {});
  },

  async forgotPassword(email: string): Promise<void> {
    await getHttpClient().post('/auth/password/reset', { email });
  },

  async resetPassword(token: string, password: string): Promise<void> {
    await getHttpClient().post('/auth/password/confirm-reset', { token, newPassword: password });
  },

  async verifyInvite(token: string): Promise<{ valid: boolean; email: string }> {
    const { data } = await getHttpClient().post<unknown>('/auth/invite/verify', { token });
    const envelope = data as { data?: { valid: boolean; email: string } };
    return (envelope.data ?? data) as { valid: boolean; email: string };
  },

  async acceptInvite(token: string, newPassword: string): Promise<void> {
    await getHttpClient().post('/auth/invite/accept', { token, newPassword });
  },
} as const;
